var Aneox;
(function (Aneox) {
  'use strict';

  var Distributors = (function () {

    var animations;
    var locale;
    var scroll;

    var distributorPageElement;
    var distributorPageList;
    var distributorPageListWrapper;
    var distributorWrapper;

    var continentIds;
    var currentContinentIndex;
    var countsContinents;
    var countsRendered = false;
      
    var dataContinents;

    function Distributors(anims, lang, scrolling) {
      animations = anims;
      locale = lang;
      scroll = scrolling;

      distributorPageElement = $('#distributor');
      distributorPageList = $('#distributor-page-list');
      distributorPageListWrapper = $('#distributor-page-list-wrapper');
      distributorWrapper = $('#distributor-wrapper');
    }

    function openPage(continent, countryId) {        
      currentContinentIndex = continentIds.indexOf(continent.tid);
      scroll.incrementScrollRetainCount();
      populatePage(continent, locale.getLocale(), countryId);
      //populatePage(dataContinents, locale.getLocale());
      animations.openOverlay(distributorPageElement);
    }

    Distributors.prototype.closePage = function() {
      animations.closeOverlay(distributorPageElement, function() {
        distributorPageListWrapper.mCustomScrollbar('destroy');
      });
      scroll.decrementScrollRetainCount();
    };

    function renderCounts(continents) {
        
      if (countsRendered) return;

      countsContinents = continents.length;
      if (countsContinents > 0) {
        countsRendered = true;
      }

      $('#distributors-count-continents').text(countsContinents);
      $('.js-distributors-count-countries').text(continents.reduce(function(accumulator, continent) {
        var nbCountries = continent.countries.length;
        return accumulator + nbCountries;
      }, 0));
      $('#distributors-count-distributors').text(continents.reduce(function(accumulator, continent) {
        return accumulator + countDistributors(continent);
      }, 0));
    }

    function countDistributors(node) {
      if (node.distributors) {
        if (_.isArray(node.distributors)) {
          return node.distributors.length;
        } else {
          return 1;
        }
      }

      if (node.countries) {
        return node.countries.reduce(function(accumulator, country) {
          return accumulator + countDistributors(country);
        }, 0);
      }
    }

    function renderLists(continents) {
      var fragment = $(document.createDocumentFragment());
      continents.forEach(function(continent) {
        var name = _.isArray(continent.name) ?
          _.find(continent.name, { locale: locale.getLocale() }).value : continent.name;

        var li = $('<li/>');
        var button = $('<button class="button-expand"><span class="line-wrapper"><span class="line">' + 
          name +
          ' <span class="coloured">(' + countDistributors(continent) + ')</span>' +
        '</span></span></button>').appendTo(li);

        var sublist = $('<ul class="distributors-sublist list-unstyled"></ul>').appendTo(li);

        button.click(function() {
          sublist.slideToggle();
        });

        continent.countries.forEach(function(country) {
          var name = _.isArray(country.name) ?
            _.find(country.name, { locale: locale.getLocale() }).value : country.name;
          var subli = $('<li/>');
          var button = $('<button class="button-unstyled">' + name + '</button>')
          .appendTo(subli);
          button.click(function() {
            openPage(continent, country.tid);
          });
          sublist.append(subli);
        }, $(''));

        fragment.append(li);
      });
      $('#distributors-list').html(fragment);
    }

    function populatePage(continent, locale, countryId) {
      var name = _.isArray(continent.name) ?
        _.find(continent.name, { locale: locale }).value : continent.name;
        
      $('#distributor-title').text(name);
      $('#distributor-photo').attr('src', continent.img);

      distributorPageList.empty();

      distributorPageList.append(continent.countries.reduce(function(accumulator, country) {
        return accumulator + '<li id="distributor-country-item-' + country.tid + '">' +
          '<h3 class="distributor-country">' +
            (_.isArray(country.name) ? _.find(country.name, { locale: locale }).value : country.name) +
          '</h3>' +
          generateDistributors(country) +
        '</li>';
      }, ''));

      distributorPageListWrapper.mCustomScrollbar({
        scrollbarPosition: 'outside',
        scrollButtons: {
          enable: true,
          scrollType: 'stepped',
          scrollAmount: 200
        },
        callbacks: {
          onInit: function() {
            $(this).find('.mCSB_buttonUp').addClass('disabled');

            if (countryId) {
              distributorPageListWrapper.mCustomScrollbar('scrollTo',
                $('#distributor-country-item-' + countryId), { scrollInertia: 0 });
            }
          },
          onScroll: function() {
            if (this.mcs.topPct === 0) {
              $(this).find('.mCSB_buttonUp').addClass('disabled');
              $(this).find('.mCSB_buttonDown').removeClass('disabled');
            } else if (this.mcs.topPct === 100) {
              $(this).find('.mCSB_buttonDown').addClass('disabled');
              $(this).find('.mCSB_buttonUp').removeClass('disabled');
            } else {
              $(this).find('.mCSB_buttonUp, .mCSB_buttonDown').removeClass('disabled')
            }
          }
        }
      });
    }

    function generateDistributors(country) {
      if (!_.isArray(country.distributors)) {
        country.distributors = [country.distributors];
      }

      return '<ul class="distributor-page-sublist list-unstyled">' +
      country.distributors.reduce(function(accumulator, distributor) {
        return accumulator + '<li>' + 
          _.reduce(distributor, function(accumulator, value, key) {
            
            switch(key) {
              case 'name':
                return value != null ? accumulator + value : accumulator;
                break;
             case 'address':
                value = _.replace(value,/<[\/]{0,1}(P|p)[^><]*>/g,"");     
                return value != null ? accumulator + '<br>'+ value : accumulator;
                break;
              case 'tel':
                return value != null ? accumulator + '<br>Tel. <a href="tel:' + value + '">' + value + '</a>' : accumulator;
                break;
             case 'fax':
                return value != null ? accumulator + '<br>Fax. <a href="tel:' + value + '">' + value + '</a>' : accumulator;
                break;
              case 'website':
                return value != null ? accumulator + '<br><a target="_blank" href="http://' + value + '">' + value + '</a>' : accumulator;
                break;
              case 'email':
                return value != null ? accumulator + '<br><a href="mailto:' + value + '">' + value + '</a>' : accumulator;
                break;
              default:
                return accumulator;
            }
          }, '') +
        '</li>';
      }, '') + '</ul>';
    }

    function switchContinent(index) {  
        
      distributorPageListWrapper.mCustomScrollbar('destroy')
      .css('overflow', 'hidden');
      var distributorWrapperTemp = distributorWrapper.clone()
      .attr('id', 'distributor-wrapper-temp')
      .insertAfter(distributorWrapper);
      distributorWrapper.css('opacity', 0);

      //populatePage(Aneox.Data.Data.distributors.continents[index], locale.getLocale());
      populatePage(dataContinents[index], locale.getLocale());

      TweenMax.to(distributorWrapper, .5, { opacity: 1 });
      TweenMax.to(distributorWrapperTemp, .5, {
        opacity: 0,
        onComplete: function() {
          distributorWrapperTemp.remove();
        }
      });
    }
      
    Distributors.prototype.appendDataList = function(locale){
      if(countsRendered){
        renderLists(dataContinents);
      }
      
      var dataCountries = app.dataCountries;
      var tempContinents = _.filter(dataCountries, {parentTid: 0});
      var dataDistributors = app.dataImport;
      var countries = _.filter(dataCountries, function(o){
        if(o.parentTid != 0) return o;
      });
      continentIds = tempContinents.map(function(continent) {
        return continent.tid;
      });
      
      tempContinents.forEach(function(continent){
          
        var name = _.isArray(continent.name) ?
          _.find(continent.name, { locale: 'fr' }).value : continent.name;
        delete continent.name;
        
        continent.countries = [];
        continent.name = [];
        continent.name.push({locale: "fr", value: name}, {locale: "en", value: continent.localeEn});

        countries.sort(function(c1, c2) {
          var name1 = _.isArray(c1.name) ? _.find(c1.name, { locale: locale }).value : c1.name;
          var name2 = _.isArray(c2.name) ? _.find(c2.name, { locale: locale }).value : c2.name;
          if (name1 > name2) {
            return 1;
          } else if (name1 < name2) {
            return -1;
          } else {
            return 0;
          }
        });

        countries.forEach(function(country){
            
          if(country.parentTid === continent.tid){
              
            var countryName = _.isArray(country.name) ?
              _.find(country.name, { locale: 'fr' }).value : country.name;
            delete country.name
            
            country.distributors = [];
            country.name = [];
            
            country.name.push({locale: "fr", value: countryName}, {locale: "en", value: country.localeEn});
            continent.countries.push(country);
            dataDistributors.forEach(function(distributor){
                
              if(distributor.countries == country.tid){
                country.distributors.push(distributor);
              }
            });
            
            if(country.distributors.length == 0){
              _.pull(continent.countries, country);
            }   
          }
        });
      });
      
      dataContinents = tempContinents.filter(function(el){
          if(el.countries.length > 0) return el;
      });
      
      renderCounts(dataContinents);
      renderLists(dataContinents);
    }   

    Distributors.prototype.next = function() {
      currentContinentIndex = (currentContinentIndex + 1) % countsContinents;
      switchContinent(currentContinentIndex);
    };

    Distributors.prototype.previous = function() {
      currentContinentIndex = (currentContinentIndex - 1) % countsContinents;
      if (currentContinentIndex < 0) {
        currentContinentIndex += countsContinents;
      }
      switchContinent(currentContinentIndex);
    }

    return Distributors;
  })();

  Aneox.Distributors = Distributors;
})(Aneox || (Aneox = {}));